module.exports = __webpack_public_path__ + "static/media/title_about.164756d7.svg";